<template>
    <div v-if="isAuthorized" :class="{ 'favorite-toggle': true, 'favorite-toggle--loading': loading }">
        <div v-if="toggle" @click.stop="removeFavorite">
            <IconLikeOn class="favorite-toggle__btn" />
        </div>
        <div v-else @click.stop="setFavorite" class="favorite-toggle__btn-off">
            <IconLikeOff class="favorite-toggle__btn" />
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import IconLikeOff from '@/views/track/icons/IconLikeOff.vue';
import IconLikeOn from '@/views/track/icons/IconLikeOn.vue';

const favoritesEnum = {
    projects: 'projectIds',
    internships: 'internshipIds',
    events: 'eventIds',
};

export default {
    components: {
        IconLikeOff,
        IconLikeOn,
    },
    props: {
        entityId: {
            type: [String, Number],
            required: true,
        },
        entityType: {
            type: String,
            required: true,
        },
    },

    data() {
        return {
            loading: false,
        };
    },

    computed: {
        ...mapGetters('track', ['favorites']),
        ...mapGetters('auth', ['isAuthorized']),

        toggle() {
            if (this.favorites && favoritesEnum[this.entityType]) {
                return this.favorites[favoritesEnum[this.entityType]].some((id) => id === this.entityId);
            }
            return false;
        },
    },

    methods: {
        ...mapActions('track', ['addEntityToFavorites', 'removeEntityToFavorites']),

        setFavorite() {
            this.addEntityToFavorites({
                type: this.entityType,
                id: this.entityId,
                groupName: favoritesEnum[this.entityType],
            });
        },
        async removeFavorite() {
            this.loading = true;
            await this.removeEntityToFavorites({
                type: this.entityType,
                id: this.entityId,
                groupName: favoritesEnum[this.entityType],
            });
            this.loading = false;
        },
    },
};
</script>

<style lang="scss" scoped>
@import '~@/styles/rem';
@import '~@/styles/variables';

.favorite-toggle {
    cursor: pointer;
    &__btn {
        user-select: none;
        width: urem(32);
        height: urem(32);
    }

    &--loading {
        cursor: not-allowed;
        pointer-events: none;
        animation: pulse 1s ease-in-out infinite;
    }
}

@keyframes pulse {
    0%,
    100% {
        transform: scale(1);
        opacity: 1;
    }
    50% {
        transform: scale(1.2);
        opacity: 0.6;
    }
}
</style>
